// events are segregated according to steps/screens
const MOBILE_EVENT = {
  mobileSubmit: "Signup_Mobile_Submit",
  mobileOtp: "Signup_Mobile_OTP",
  resendOtp: "Signup_Resend_OTP",
  tAndC: "Signup_T&C",
}

const EMAIL_EVENT = {
  emailSubmit: "Signup_Email_Submit",
  emailOtp: "Signup_Email_OTP",
  resendOtp: "Signup_Resend_OTP",
}

const PAN_EVENT = {
  panSubmit: "Signup_PAN_Submit",
}

const KYC_EVENT = {
  kycVerification: "Signup_KYC_Verification",
  kycReceived: "Signup_KYC_Received",
}

const PERSONAL_DETAILS_EVENT = {
  gender: "Signup_Gender",
  maritalStatus: "Signup_Marital_Status",
  occupation: "Signup_Occupation",
  income: "Signup_Income",
  tradingExperience: "Signup_Trading_Experience",
  parentsName: "Signup_Parents_Name",
  segmentSubmit: "Signup_Segment_Submit",
}

const BANK_DETAILS_EVENT = {
  bankDetails: "Signup_Bank_Details",
  bankDetailsSetu: "Signup_Bank_Setu_verified",
  searchManual: "Signup_Bank_Search_Manual",
  bankSubmit: "Signup_Bank_Submit",
  bankError: "Signup_Bank_Error",
}

const LIVELINESS_EVENT = {
  liveliness: "Signup_Liveliness",
  livelinessSuccess: "Signup_Liveliness_Success",
}

const SIGNATURE_EVENT = {
  signatureUpload: "Signup_Signature_Upload",
  signatureUploadNext: "Signup_Signature_Next",
}

const NOMINEE_EVENT = {
  nominee: "Signup_Nominee",
}

const FNO_EVENT = {
  enableFnO: "Signup_Enable_FnO",
  enableFnoManual: "Signup_Enable_FnO_Manual",
  enableFnoError: "Signup_FnO_Error",
  enableFnoSetu: "Signup_FnO_enabled_Setu",
}

const ESIGN_EVENT = {
  kyc: "Signup_esign_KYC",
  kra: "Signup_esign_CVLKRA",
  esignError: "Signup_esign_error",
  esignComplete: "Signup_Complete",
}

const PAGE_LANDING_EVENT = {
  mobileLanding: "Signup_Mobile_landing",
  mobileOtpLanding: "Signup_Mobile_OTP_landing",
  emailLanding: "Signup_Email_landing",
  emailOtpLanding: "Signup_Email_OTP_landing",
  panLanding: "Signup_PAN_Landing",
  kycLanding: "Signup_KYC_Landing",
  genderLanding: "Signup_Gender_Landing",
  experienceLanding: "Signup_Experience_Landing",
  occupationLanding: "Signup_Occupation_Landing",
  incomeLanding: "Signup_Income_Landing",
  maritalStatusLanding: "Signup_Marital_Status_Landing",
  parentNameLanding: "Signup_Parent_Name_Landing",
  segmentLanding: "Signup_Segment_Landing",
  livelinessLanding: "Signup_Liveliness_Landing",
  signatureLanding: "Signup_Signature_Landing",
  nomineeLanding: "Signup_Nominee_Landing",
  eSignLanding: "Signup_ESign_Landing",
}

export {
  MOBILE_EVENT,
  EMAIL_EVENT,
  PAN_EVENT,
  KYC_EVENT,
  PERSONAL_DETAILS_EVENT,
  BANK_DETAILS_EVENT,
  LIVELINESS_EVENT,
  SIGNATURE_EVENT,
  NOMINEE_EVENT,
  FNO_EVENT,
  ESIGN_EVENT,
  PAGE_LANDING_EVENT,
}
